import type { Modules } from '@tsTypes/api/Modules';
import useAppConfig from '@hooks/useAppConfig';

const useAppModuleConfig = <T extends keyof Modules>(module: T) =>
  useAppConfig().data.modules[module];

export default useAppModuleConfig;
